import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

const TOPBAR_AND_TITLE_HEIGHT = '183px'

export const NoNotificationsMessageStyle = css`
  padding: ${spacing(5)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_sm};
  line-height: 16px;
`

export default css`
  width: 100%;
  height: calc(100vh - ${TOPBAR_AND_TITLE_HEIGHT});
`
